module.exports = new __parcel__URL__("bruiser.7d408668.png").toString();